import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import pretty from "Shared/pretty";
import React, { FC } from "react";
import { DPPayPeriodSummary } from "Shared/types/Payments";
import Grid from "@material-ui/core/Grid";
import { DPChip, DPPercentagePill } from "Components/DP";
import useStyles from "./styles";

const Summary: FC<DPPayPeriodSummary> = summary => {
  const classes = useStyles();
  const {
    netEarningsAmountCents,
    totalTransferredEarlyAmountCents,
    totalFeeAmountCents,
    remainderAmountCents,
    negativeBalancePaidSettlementAmountCents,
  } = summary;

  return (
    <Box id="payments-summary" className={classes.summary}>
      <Typography align="center" variant="h4">
        Their Paycheck
      </Typography>
      <Typography align="center" variant="h2">
        {pretty.dollar(netEarningsAmountCents)}
      </Typography>
      <DPPercentagePill {...summary} />
      <Grid container alignItems="baseline" justify="center">
        <Grid
          container
          justify="center"
          direction="column"
          item
          className={classes.gridItem}
        >
          <DPChip
            align="center"
            color="secondary"
            className={classes.chip}
            label={
              <b>
                {pretty.dollar(
                  totalTransferredEarlyAmountCents + totalFeeAmountCents
                )}
              </b>
            }
          />
          <Typography variant="caption" align="center" display="block">
            Transferred before payday <br />
            {`(includes ${pretty.dollar(totalFeeAmountCents)} in fees).`}
          </Typography>
        </Grid>
        {!!negativeBalancePaidSettlementAmountCents && (
          <Grid
            container
            justify="center"
            direction="column"
            item
            className={classes.gridItem}
          >
            <DPChip
              align="center"
              color="warn"
              className={classes.chip}
              label={
                <b>{pretty.dollar(negativeBalancePaidSettlementAmountCents)}</b>
              }
            />
            <Typography variant="caption" align="center" display="block">
              Their payment to DailyPay for a previous negative balance
            </Typography>
          </Grid>
        )}
        <Grid
          container
          justify="center"
          direction="column"
          item
          className={classes.gridItem}
        >
          <DPChip
            align="center"
            color="primary"
            className={classes.chip}
            label={<b>{pretty.dollar(remainderAmountCents)}</b>}
          />
          <Typography variant="caption" align="center" display="block">
            Their remaining balance for this pay period.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Summary;
